import { render, staticRenderFns } from "./SideTagsRecordDialog.vue?vue&type=template&id=fffdca5e&scoped=true&"
import script from "./SideTagsRecordDialog.vue?vue&type=script&lang=js&"
export * from "./SideTagsRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsRecordDialog.vue?vue&type=style&index=0&id=fffdca5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffdca5e",
  null
  
)

export default component.exports